import jquery from 'jquery';

import bootstrap from 'bootstrap';
import flickity from 'flickity';

window.$ = window.jQuery = window.jquery = jquery;
window.Flickity = flickity;

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});


$('[data-mobile-menu="close"]').on('click', (event) => {
    event.preventDefault();
    let $hamburger = $('.hamburger[data-toggle="collapse"][href="#dropdownCollapse"]');
    $hamburger.click();
    $('html').removeClass('dropdown-open');
    $('body').removeClass('dropdown-open');
    $('.header-backdrop').addClass('d-none');
})